import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../lib/supabase'
import { useFirm } from '../../hooks/use-firm'

export interface FirmProfile {
  id: string
  name: string
  phone: string | null
  address: string | null
  website: string | null
  service_lines: string[]
  onboarding_completed: boolean
}

export function useFirmProfile() {
  const { firmId } = useFirm()

  return useQuery({
    queryKey: ['firm_profile', firmId],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('firms')
        .select('id, name, phone, address, website, service_lines, onboarding_completed')
        .eq('id', firmId)
        .single()
      if (error) throw error
      return data as FirmProfile
    },
    enabled: !!firmId,
  })
}

export function useUpdateFirmProfile() {
  const { firmId } = useFirm()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (updates: Partial<Omit<FirmProfile, 'id'>>) => {
      const { error } = await (supabase as any)
        .from('firms')
        .update(updates)
        .eq('id', firmId)
      if (error) throw error
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['firm_profile', firmId] }),
  })
}
